import React, { Fragment, useEffect, useRef } from "react";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import { Response_FileDowloadData } from "@genericComponents/CFW.js";
import { RemoveState } from "@genericComponents/StoreToolkit.js";
import { LinkNav } from "@controls/LinkNav.js";
export const FileDownloader = () => {
  const fileDownLoadResults = useGenericStore(Response_FileDowloadData);
  const aHref = useRef(null);
  useEffect(() => {
    if (fileDownLoadResults && aHref.current) {
      aHref.current.click();
      RemoveState(Response_FileDowloadData);
    }
    return () => {};
  }, [fileDownLoadResults]);
  return fileDownLoadResults ? (
    <LinkNav
      className="displayNone"
      ref={aHref}
      target="_blank"
      download={
        parseInt(fileDownLoadResults?.AttachmentTypeId, 0) !== 6
          ? fileDownLoadResults.FileName
          : null
      }
      rel="noreferrer noopener"
      to={fileDownLoadResults.Url}
    />
  ) : (
    <Fragment />
  );
};
